export function generateGetBoundingClientRect(_ref) {
  var {
    x,
    y
  } = _ref;
  return () => ({
    width: 0,
    height: 0,
    top: y,
    right: x,
    bottom: y,
    left: x,
    x,
    y,
    toJSON() {}
  });
}